import { render, staticRenderFns } from "./Steuer.vue?vue&type=template&id=80d7e92c&"
import script from "./Steuer.vue?vue&type=script&lang=js&"
export * from "./Steuer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports